import ChatItemSkeleton from "./ChatItem/skeleton";

export default function ChatListSkeleton() {
  return (
    <>
      {Array.from({ length: 6 }).map((_, index) => (
        <ChatItemSkeleton key={index} />
      ))}
    </>
  );
}
